"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLatestItemByDate = getLatestItemByDate;
function getLatestItemByDate(items, field) {
    return items.toSorted((a, b) => b[field].getTime() - a[field].getTime()).at(0);
}
//# sourceMappingURL=getLatestItemByDate.js.map